module.exports = __webpack_public_path__ + "static/media/RI-D4-0.4-082.22f75dd8.webp";